export const bestViewedOnDesktopStyles = {
	bestOnDesktopBannerWrapper: {
		width: '100%',
	},

	bestOnDesktopBanner: {
		width: '100%',
		padding: '10px',

		backgroundColor: 'colors.vividBlue600',

		display: 'flex',
		justifyContent: 'center',
	},
};
